'use strict';

window.jQuery = window.$ = require('jquery');

const processInclude = require('base/util');
require('core/components/spinner');
// Loaded now, not on ready: it sets the page-level Tealium variables before utag.js sends the page view
const revampEvents = require('./tealium/revampEvents');

$(document).ready(function () {
  processInclude(require('./login'));
  processInclude(require('./common'));
  processInclude(require('./product/colorSwatches'));
  processInclude(require('./components/wishlist'));
  processInclude(require('tealium/tealiumEvents'));
  // After tealiumEvents: some handlers replace the shared ones with .off()
  processInclude(revampEvents);
});

require('base/thirdParty/bootstrap');
